import React from "react";
import {useSearchParams} from "react-router-dom";
import {useSetting} from "../../contexts/setting";
import {useEdits} from "../../contexts/edits";
import cn from "classnames";
import "./index.css";
import {PLACEHOLDERS} from "../../data/constants";

const Button = ({value, handleClick, isCurrent}) => {
  const btnClass = cn("font-button", {selected: isCurrent});
  return (
    <button value={value} className={btnClass} onClick={() => handleClick(value)}>
      {value.toUpperCase()}
    </button>
  );
};

const FontSelector = () => {
  const {fontOption, editFontOption} = useSetting();
  const {editTitles, editSubtitles} = useEdits();
  const labels = Object.keys(PLACEHOLDERS);
  const [, setSearchParams] = useSearchParams();

  // Reset the title/subtitle to the picked language's placeholder copy ONLY on
  // an explicit language switch. This used to live in a `useEffect([fontOption])`
  // that also fired on mount — which clobbered a saved scene's custom localized
  // copy when it loaded with Localization on (fontOption is restored by the
  // reducer, not by a click). Driving it from the click keeps scene loads intact.
  const onBgButtonClick = (value) => {
    editFontOption(value);
    editTitles(PLACEHOLDERS[value].title);
    editSubtitles(PLACEHOLDERS[value].subtitle);
    setSearchParams(
      (params) => {
        params.set("localization", value);
        return params;
      },
      {replace: true}
    );
  };

  return (
    <div className="font-selector">
      {labels.map((x) => (
        <Button key={x} value={x} handleClick={onBgButtonClick} isCurrent={fontOption === x} />
      ))}
    </div>
  );
};

export default FontSelector;
